<script>
import VueQr from 'vue-qr'

export default {
  components: { VueQr },
  page: {
    title: 'Reset Password',
    meta: [{ name: 'description', content: 'The Reset Password page.' }],
  },
  computed: {
    isMobileDevice() {
      const userAgent = navigator.userAgent.toLowerCase()
      return /android|webos|iphone|ipad|ipod|blackberry|windows phone/.test(
        userAgent
      )
    },
    confirmLink() {
      const token = this.$route.params.token
      const uid = this.$route.params.uid

      const url = new URL(window.location.href)
      const hostname = url.hostname.split('.')
      const environment = hostname[0]

      const environmentMap = {
        staging: 'hbp-staging',
        dev: 'hbp-development',
        silverhand: 'hbp-silverhand',
        myhealthbookplus: 'hbp', // For production without subdomain
      }
      const customScheme = environmentMap[environment] || 'hbp'

      return `${customScheme}://(auth)/confirm-reset-password?token=${token}&uid=${uid}`
    },
    qrCodeLink() {
      return window.location.href
    },
  },
  mounted() {
    const token = this.$route.params.token
    const uid = this.$route.params.uid

    if (!token || !uid) {
      this.$router.push({ name: 'login' })
    }
    if (this.isMobileDevice) {
      window.location.href = this.confirmLink
    }
  },
}
</script>

<template>
  <v-container fluid class="px-6">
    <v-row>
      <v-col :class="$style.title"> Reset Password </v-col>
    </v-row>

    <v-row v-if="isMobileDevice">
      <v-col cols="12" class="py-2 px-2 font-weight-bold">
        We are currently in the process of resetting your password for the
        HealthBook+ app.
      </v-col>
      <v-col cols="12" class="py-2 px-2">
        If the app does not open automatically, kindly use the link below to
        confirm your password reset:
      </v-col>
      <v-col cols="12" class="py-2 px-2">
        <a :href="confirmLink">Reset Password</a>
      </v-col>
      <v-col cols="12" class="py-2 px-2">
        This link will directly lead you to the HealthBook+ app for the purpose
        of resetting your password.
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="12" :class="$style.description">
        To confirm the password reset, please use your mobile device's camera to
        scan the QR Code below.
      </v-col>
      <v-row justify="center">
        <VueQr :text="qrCodeLink" :size="250"></VueQr>
      </v-row>
      <v-col cols="12" class="mb-4" :class="$style.description">
        Scanning this QR code will automatically redirect you to the password
        reset page.
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.title {
  font-size: 1.25em;
  text-align: center;
}
.description {
  font-size: 0.9em;
}
</style>
